export const CategoriesTravelActionTypes = {
  API_RESPONSE_SUCCESS: '@@category-travel/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@category-travel/API_RESPONSE_ERROR',

  GET_CATEGORY_TRAVEL: '@@category-travel/GET_CATEGORY_TRAVEL',
  LIST_CATEGORIES_TRAVEL: '@@category-travel/LIST_CATEGORIES_TRAVEL',
  ADD_CATEGORY_TRAVEL: '@@category-travel/ADD_CATEGORY_TRAVEL',
  UPDATE_CATEGORY_TRAVEL: '@@category-travel/UPDATE_CATEGORY_TRAVEL',
  DELETE_CATEGORY_TRAVEL: '@@category-travel/DELETE_CATEGORY_TRAVEL',

  RESET: '@@category-travel/RESET'
}
